import { render } from "./KnowledgeCardForLive.vue?vue&type=template&id=0d4a25e2&scoped=true"
import script from "./KnowledgeCardForLive.vue?vue&type=script&lang=js"
export * from "./KnowledgeCardForLive.vue?vue&type=script&lang=js"

import "./KnowledgeCardForLive.vue?vue&type=style&index=0&id=0d4a25e2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4a25e2"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QImg});
